import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, Check, AlertTriangle } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const PublisherVerifyPage = () => {
  const { token } = useParams();
  const { lang } = useLang();
  const isNl = lang === "nl";
  const [state, setState] = useState("loading");

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API}/apps/claim/verify/${token}`, { credentials: "include" });
        if (res.ok) {
          setState("ok");
          setTimeout(() => { window.location.href = "/publisher/dashboard"; }, 800);
        } else {
          setState("invalid");
        }
      } catch (e) { setState("invalid"); }
    })();
  }, [token]);

  return (
    <main className="hac-container py-24 text-center max-w-md" data-testid="publisher-verify">
      {state === "loading" && <><Loader2 size={48} className="animate-spin mx-auto text-[#2563EB] mb-4" /><p className="text-[#64748B]">{isNl ? "Bezig met verifiëren..." : "Verifying..."}</p></>}
      {state === "ok" && <><Check size={48} className="mx-auto text-emerald-600 mb-4" /><h1 className="font-heading text-2xl text-[#0F172A] mb-2">{isNl ? "✅ Geverifieerd!" : "✅ Verified!"}</h1><p className="text-[#64748B]">{isNl ? "We brengen je naar je dashboard..." : "Taking you to your dashboard..."}</p></>}
      {state === "invalid" && <><AlertTriangle size={48} className="mx-auto text-amber-600 mb-4" /><h1 className="font-heading text-2xl text-[#0F172A] mb-2">{isNl ? "Link ongeldig" : "Invalid link"}</h1><p className="text-[#64748B]">{isNl ? "Deze verificatie-link is verlopen of al gebruikt." : "This verification link is expired or already used."}</p></>}
    </main>
  );
};

export default PublisherVerifyPage;
